<template>
  <div
    class="views-page is-flex is-flex-direction-column p-3 pb-5"
    style="min-height: 50vh"
  >
    <div
      class="info-line"
      :class="GetMessagesData.main_color"
    />
    <b-loading
      :is-full-page="false"
      v-model="isLoading"
      :can-cancel="false"
    />
    <div class="is-flex is-flex-direction-column" style="gap: 1rem">
      <h2 class="is-size-5 has-text-weight-semibold mb-3 is-flex is-align-items-center is-justify-content-space-between">
        {{ GetMessagesData.device_name }} | Рассылка
      </h2>

      <!-- Форма для ввода почт -->
      <div v-if="!isLoading && emails.length > 0">
        <h3 class="is-size-6 has-text-weight-semibold mb-3">
          Список получателей ({{ emails.length }})
        </h3>
        <div class="tags">
          <b-tag
            v-for="email in emails"
            :key="email"
            type="is-info"
            closable
            @close="onEmailDelete(email)"
          >
            {{ email }}
          </b-tag>
        </div>
      </div>

      <p v-if="!isLoading && emails.length === 0" class="has-text-centered has-text-grey">
        Нет добавленных email адресов
      </p>
      <div>
        <h3 class="is-size-6 has-text-weight-semibold mb-3">Добавить получателей</h3>
        <b-field
          label="Список email адресов (через запятую)"
          :type="emailsError ? 'is-danger' : ''"
          :message="emailsError"
        >
          <b-input
            v-model="emailsInput"
            type="textarea"
            placeholder="example1@mail.com, example2@gmail.com, example3@yandex.ru"
            rows="4"
            maxlength="2000"
            :loading="isSubmitting"
          />
        </b-field>

        <div class="is-flex is-justify-content-flex-end" style="gap: 0.5rem">
          <b-button
            @click="clearEmails"
            :disabled="!emailsInput.trim()"
          >
            Очистить
          </b-button>
          <b-button
            type="is-primary"
            @click="submitEmails"
            :loading="isSubmitting"
            :disabled="!emailsInput.trim()"
          >
            Добавить почты
          </b-button>
        </div>

        <!-- Предварительный просмотр валидных почт -->
        <!--        <div v-if="validEmails.length > 0 && !emailsError" class="mt-3">-->
        <!--          <p class="is-size-7 has-text-grey mb-2">Предварительный просмотр</p>-->
        <!--          <div class="tags">-->
        <!--            <span-->
        <!--              v-for="email in validEmails.slice(0, 10)"-->
        <!--              :key="email"-->
        <!--              class="tag is-small is-info"-->
        <!--            >-->
        <!--              {{ email }}-->
        <!--            </span>-->
        <!--            <span v-if="validEmails.length > 10" class="tag is-small is-light">-->
        <!--              +{{ validEmails.length - 10 }} еще-->
        <!--            </span>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex"

export default {
  props: ["device_id"],
  data() {
    return {
      emails: [],
      isLoading: true,
      emailsInput: '',
      emailsError: '',
      isSubmitting: false,
      validEmails: []
    }
  },
  computed: {
    ...mapGetters(["GetMessagesData", "getUser"]),
    isManager() {
      return this.getUser?.role_id === 3
    }
  },
  watch: {
    emailsInput: {
      handler(newVal) {
        this.validateEmails(newVal)
      },
      immediate: true
    }
  },
  created() {
    // this.ChangeNavName("Архивные сообщения")
    this.FetchMessages(this.device_id)
    this.getEmails()
  },
  methods: {
    ...mapActions(["FetchMessages"]),
    ...mapMutations(["ChangeNavName"]),

    async getEmails() {
      this.isLoading = true
      try {
        const { data } = await this.$axios.get(`manager/agents/${this.device_id}/ai-emails`)
        this.emails = data?.emails || []
      } catch (e) {
        this.isLoading = false
        throw new Error(e)
      }
      this.isLoading = false
    },

    async deleteEmail(email) {
      try {
        await this.$axios.delete(`manager/agents/${this.device_id}/ai-emails`, {
          data: { email }
        })
        await this.getEmails()
        this.$buefy.toast.open({
          message: 'Email адрес успешно удален',
          type: 'is-success'
        })
      } catch (e) {
        console.error(e)
        this.$buefy.toast.open({
          message: 'Ошибка при удалении email адреса',
          type: 'is-danger'
        })
        throw e
      }
    },

    onEmailDelete(email) {
      this.$buefy.dialog.confirm({
        title: 'Подтвердите удаление',
        message: `Вы уверены, что хотите удалить адрес <strong>${email}</strong>? Это действие необратимо.`,
        confirmText: 'Да, удалить',
        cancelText: 'Отмена',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deleteEmail(email)
        }
      })
    },

    validateEmails(input) {
      this.emailsError = ''
      this.validEmails = []

      if ( !input || !input.trim()) {
        return
      }

      try {
        // Парсим строку - разделяем по запятым и убираем пробелы
        const emailList = input
          .split(',')
          .map(email => email.trim())
          .filter(email => email.length > 0)

        if (emailList.length === 0) {
          this.emailsError = 'Введите хотя бы один email адрес'
          return
        }

        // Простая регулярка для валидации email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        const validEmails = []
        const invalidEmails = []

        emailList.forEach(email => {
          if (emailRegex.test(email)) {
            validEmails.push(email)
          } else {
            invalidEmails.push(email)
          }
        })

        if (invalidEmails.length > 0) {
          this.emailsError = `Некорректные email адреса: ${invalidEmails.slice(0, 3).join(', ')}${invalidEmails.length > 3 ? ` и еще ${invalidEmails.length - 3}` : ''}`
          return
        }

        // Проверяем на дубликаты
        const uniqueEmails = [...new Set(validEmails)]
        if (uniqueEmails.length !== validEmails.length) {
          this.emailsError = 'Найдены дублирующиеся email адреса'
          return
        }

        // Проверяем на уже существующие email адреса
        const existingEmails = uniqueEmails.filter(email => this.emails.includes(email))
        if (existingEmails.length > 0) {
          this.emailsError = `Email адреса уже добавлены: ${existingEmails.slice(0, 3).join(', ')}${existingEmails.length > 3 ? ` и еще ${existingEmails.length - 3}` : ''}`
          return
        }

        this.validEmails = uniqueEmails

      } catch (e) {
        this.emailsError = 'Ошибка при обработке списка email адресов'
        console.error('Email parsing error:', e)
      }
    },

    async submitEmails() {
      if (this.validEmails.length === 0) {
        this.$buefy.toast.open({
          message: 'Нет валидных email адресов для отправки',
          type: 'is-warning'
        })
        return
      }

      this.isSubmitting = true

      try {
        // Отправляем массив email адресов на бэкенд
        const payload = {
          emails: this.validEmails
        }

        const { data } = await this.$axios.post(`manager/agents/${this.device_id}/ai-emails`, payload)
        console.log(data)
        this.$buefy.toast.open({
          message: `Успешно добавлено ${this.validEmails.length} email адресов`,
          type: 'is-success'
        })

        // Очищаем форму и обновляем список
        this.clearEmails()
        await this.getEmails()

      } catch (e) {
        console.error('Submit emails error:', e)
        this.$buefy.toast.open({
          message: e.response?.data?.message || 'Ошибка при добавлении email адресов',
          type: 'is-danger'
        })
      } finally {
        this.isSubmitting = false
      }
    },

    clearEmails() {
      this.emailsInput = ''
      this.emailsError = ''
      this.validEmails = []
    }
  },
}
</script>
